import type { Lighting_LuminaireModel } from "src/graphql/types";

export const dataDefaultValues: Partial<Lighting_LuminaireModel> = {
  typeId: null as any,
};
